<template>
  <div
    class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center"
  >
    <div class="fixed inset-0 transition-opacity">
      <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
    </div>

    <div
      class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6"
    >
      <div class="sm:flex sm:items-start">
        <div
          class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
        >
          <font-awesome-icon class="text-red-600" :icon="['far', 'exclamation-triangle']" />
        </div>
        <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
          <h3 class="text-lg leading-6 font-medium text-gray-900">{{header}}</h3>
          <div class="mt-2">
            <p class="text-sm leading-5 text-gray-500">{{text}}</p>
          </div>
        </div>
      </div>
      <div class="mt-5 sm:mt-4 sm:ml-10 sm:pl-4 sm:flex">
        <basic-button
          class="w-full sm:w-auto"
          button-class="w-full justify-center"
          color="red"
          @click="destroy()"
          :disabled="loading"
          :loading="loading"
          leading-icon="trash"
        >Löschen</basic-button>
        <basic-button
          class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-3 sm:w-auto"
          button-class="w-full justify-center"
          color="white"
          @click="close()"
          :disabled="loading"
        >Abbrechen</basic-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    header: {
      required: false,
      default: "Löschen",
      type: String
    },
    text: {
      required: false,
      default:
        "Diese Aktion kann nicht rückgängig gemacht werden und wird sofort verarbeitet.",
      type: String
    },
    destroyFunc: {
      required: true,
      type: Function
    }
  },

  data() {
    return {
      loading: false
    };
  },

  methods: {
    close() {
      this.$emit("close");
    },
    async destroy() {
      this.loading = true;
      this.destroyFunc().finally(() => this.close());
    }
  }
};
</script>